(function () {
  const ROOT_SELECTOR = '.home-reviews-carousel-section';

  function getNearestSlideIndex(slides, scrollLeft, viewportWidth) {
    let nearestIndex = 0;
    let nearestDistance = Number.POSITIVE_INFINITY;
    const viewportCenter = scrollLeft + viewportWidth / 2;

    slides.forEach((slide, index) => {
      const slideCenter = slide.offsetLeft + slide.clientWidth / 2;
      const distance = Math.abs(slideCenter - viewportCenter);
      if (distance < nearestDistance) {
        nearestDistance = distance;
        nearestIndex = index;
      }
    });

    return nearestIndex;
  }

  function initRoot(root) {
    if (!root || root.dataset.homeReviewsInit === 'true') return;
    root.dataset.homeReviewsInit = 'true';

    const slider = root.querySelector('[id^="Slider-"]');
    const prevButton = root.querySelector('.reviews-carousel__arrow--prev');
    const nextButton = root.querySelector('.reviews-carousel__arrow--next');
    const loop = root.dataset.loop === 'true';
    const originalSlides = slider ? Array.from(slider.querySelectorAll('.reviews-carousel__slide')) : [];
    let hasLoopClones = false;
    let scrollEndTimer = null;

    if (!slider || !originalSlides.length) return;

    if (loop && originalSlides.length > 1) {
      const firstClone = originalSlides[0].cloneNode(true);
      const lastClone = originalSlides[originalSlides.length - 1].cloneNode(true);

      firstClone.dataset.clone = 'true';
      lastClone.dataset.clone = 'true';
      firstClone.removeAttribute('id');
      lastClone.removeAttribute('id');

      slider.insertBefore(lastClone, originalSlides[0]);
      slider.appendChild(firstClone);
      hasLoopClones = true;
    }

    let slides = Array.from(slider.querySelectorAll('.reviews-carousel__slide'));
    let currentIndex = hasLoopClones ? 1 : 0;

    function getFirstIndex() {
      return hasLoopClones ? 1 : 0;
    }

    function getLastIndex() {
      return hasLoopClones ? slides.length - 2 : slides.length - 1;
    }

    function getCenteredLeft(slide) {
      const centeredLeft = slide.offsetLeft - (slider.clientWidth - slide.clientWidth) / 2;
      return Math.max(0, centeredLeft);
    }

    function normalizeIndex(index) {
      const last = slides.length - 1;
      if (hasLoopClones) {
        return Math.max(0, Math.min(index, last));
      }

      if (loop) {
        if (index < 0) return last;
        if (index > last) return 0;
      }

      return Math.max(0, Math.min(index, last));
    }

    function syncButtons() {
      if (!prevButton || !nextButton) return;

      if (originalSlides.length < 2) {
        prevButton.setAttribute('disabled', 'disabled');
        nextButton.setAttribute('disabled', 'disabled');
        return;
      }

      if (loop) {
        prevButton.removeAttribute('disabled');
        nextButton.removeAttribute('disabled');
        return;
      }

      if (currentIndex <= 0) prevButton.setAttribute('disabled', 'disabled');
      else prevButton.removeAttribute('disabled');

      if (currentIndex >= slides.length - 1) nextButton.setAttribute('disabled', 'disabled');
      else nextButton.removeAttribute('disabled');
    }

    function goTo(index, behavior) {
      currentIndex = normalizeIndex(index);

      if (!slides[currentIndex]) return;

      slider.scrollTo({
        left: getCenteredLeft(slides[currentIndex]),
        behavior: behavior || 'smooth',
      });
      syncButtons();
    }

    function normalizeLoopEdge() {
      if (!hasLoopClones) return;

      if (currentIndex === 0) {
        currentIndex = getLastIndex();
      } else if (currentIndex === slides.length - 1) {
        currentIndex = getFirstIndex();
      } else {
        return;
      }

      slider.scrollTo({
        left: getCenteredLeft(slides[currentIndex]),
        behavior: 'auto',
      });
      syncButtons();
    }

    function onScroll() {
      currentIndex = normalizeIndex(getNearestSlideIndex(slides, slider.scrollLeft, slider.clientWidth));
      syncButtons();

      if (!hasLoopClones) return;

      window.clearTimeout(scrollEndTimer);
      scrollEndTimer = window.setTimeout(normalizeLoopEdge, 90);
    }

    if (prevButton) {
      prevButton.addEventListener('click', function (event) {
        event.preventDefault();
        goTo(currentIndex - 1);
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function (event) {
        event.preventDefault();
        goTo(currentIndex + 1);
      });
    }

    slider.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener(
      'resize',
      function () {
        slides = Array.from(slider.querySelectorAll('.reviews-carousel__slide'));
        onScroll();
        goTo(currentIndex, 'auto');
      },
      { passive: true }
    );

    goTo(currentIndex, 'auto');
  }

  function initAll() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.matches && event.target.matches(ROOT_SELECTOR)) {
      initRoot(event.target);
      return;
    }
    initAll();
  });
})();
